import React from 'react';
import { Select, MenuItem } from '@material-ui/core';
import { CircularProgress } from '@mui/material';

import { useGivingAccountsSummaryQuery } from 'generated/graphql';

interface GivingAccountSelectorProps {
  input: {
    value: string;
    onChange: (value: string | null) => void;
  };
  Wrapper: React.ComponentType<{ children: React.ReactNode }>;
}

export const GivingAccountSelector = ({ input, Wrapper }: GivingAccountSelectorProps) => {
  const { data, loading } = useGivingAccountsSummaryQuery();

  if (loading) {
    return <CircularProgress size={20} />;
  }

  if ((data?.givingAccounts?.length || 0) < 2) {
    return null;
  }

  return (
    <Wrapper>
      <Select
        value={input.value || '-'}
        onChange={(event) => {
          input.onChange(event.target.value === '-' ? null : (event.target.value as string));
        }}
      >
        <MenuItem value="-">Default Account</MenuItem>
        {data?.givingAccounts.map((account) => (
          <MenuItem key={account.id} value={account.id}>
            {account.name || `${account.provider} ${account.currencyCode} Account`}
          </MenuItem>
        ))}
      </Select>
    </Wrapper>
  );
};
